export default "__VITE_ASSET__CQXDwSo___"